import React from 'react'
import { Claim } from '@dataTypes/claimFeature.types'
import { INote, NoteContextType } from '@dataTypes/note.type'
import NoteTextEditor from '@components/common/NoteTextEditor/NoteTextEditor.component'
import {
  getClaimIdForNotesHeader,
  getNotesClaimContextId,
} from '@utils/claims.util'
import type { NoteMutationSuccessDetail } from '@components/common/NoteEditorOverlay/notesFeature.types'

type ClaimAttachmentNoteProps = {
  attachmentNotes: INote[]
  onUpdateNotes: (notes: INote[]) => void
  selectedClaim: Claim
  isEditingExistingClaim: boolean
  onNoteSavedImmediate?: (note: INote) => void
  onNoteMutationSuccess?: (detail?: NoteMutationSuccessDetail) => void
}

const ClaimAttachmentNote: React.FC<ClaimAttachmentNoteProps> = ({
  attachmentNotes,
  onUpdateNotes,
  selectedClaim,
  isEditingExistingClaim,
  onNoteSavedImmediate,
  onNoteMutationSuccess,
}) => (
  <div className="claim-notes mt-2">
    <NoteTextEditor
      patientId={selectedClaim.patientIdSystem!}
      contextId={getNotesClaimContextId(selectedClaim)}
      overlayContextName={getClaimIdForNotesHeader(selectedClaim)}
      notesOverlayAnchorClassName="claims-note-editor-overlay-anchor"
      notesOverlayBodyClassName="note-overlay-from-claims"
      alwaysShowSavedNotesSection={isEditingExistingClaim}
      savedNotesAllowDelete={false}
      noteData={{
        tag: NoteContextType.CLAIMS,
      }}
      notes={attachmentNotes ?? []}
      onUpdate={(notes) => onUpdateNotes(notes as INote[])}
      onNoteSavedImmediate={onNoteSavedImmediate}
      onNoteMutationSuccess={onNoteMutationSuccess}
      claimStatusForNotes={selectedClaim.generalStatus ?? selectedClaim.status}
    />
  </div>
)

export default ClaimAttachmentNote
